export * from "./ConsentText";
